export default {
  /**
   * Nombre del componente
   */
  name: 'YuriButton',

  /**
   * Propiedades de entrada
   */
  props: {
    text: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: false,
      default: 'success',
      validator: val => ['secondary', 'submit', 'success', 'danger', 'link', 'cancel'].includes(val)
    },
    icon: {
      type: String,
      required: false
    },
    size: {
      type: String,
      required: false,
      validator: val => ['sm', 'lg'].includes(val)
    },
    solid: {
      type: Boolean,
      required: false,
      default: true
    },
    'icon-color': {
      type: String,
      requird: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    to: {
      type: Object,
      required: false
    }
  }
};
